(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("KomigenWeb", [], factory);
	else if(typeof exports === 'object')
		exports["@komigen/web"] = factory();
	else
		root["KomigenWeb"] = factory();
})(window, function() {
return 